import {
  getCategory,
  getCityByStateId,
  getState,
  organizerAddEventApi,
  organizerAddSponsorApi,
  organizerCreateCouponApi,
  organizerMeApi,
  organizerTicketTypesByEventApi,
  organizerUpdateEventApi,
} from "../../../api/api";
import { MAIN_API } from "../../../api/apilist";
import {
  formDataCertificados,
  formDataCompra,
  formDataCrearEvento,
  formDataImagenes,
  formDataPixel,
  formDataSponsor,
  hayImagenes,
  payloadCupon,
} from "./eventoPayload";

const lista = (res) => (Array.isArray(res?.data?.info) ? res.data.info : []);

export const cargarCatalogos = async () => {
  const [cats, states, me] = await Promise.all([getCategory(), getState(), organizerMeApi().catch(() => null)]);
  return { categorias: lista(cats), provincias: lista(states), me: me?.data?.info || null };
};

// Same two-attempt lookups as EventForm: the API has accepted both `stateId` and `stateid`.
export const ciudadesPorProvincia = async (stateId) => {
  try {
    const res = await getCityByStateId({ stateId });
    if (res?.data?.info === undefined) throw new Error("unexpected_response");
    return lista(res);
  } catch {
    return lista(await getCityByStateId({ stateid: stateId }));
  }
};

export const crearEvento = async (d, opts) => {
  const res = await organizerAddEventApi(formDataCrearEvento(d, opts));
  const event = res?.data?.info || {};
  const id = event._id || event.id;
  if (!id) throw new Error("No pudimos confirmar el evento creado. Revisá la lista de eventos.");
  return { id, event };
};

// EventForm uploads the default certificate template when enabling certificates without one.
const plantillaPorDefecto = async () => {
  try {
    const res = await fetch(`${MAIN_API}/assets/certificates/Certificado.jpg`);
    const blob = await res.blob();
    return new File([blob], "Certificado.jpg", { type: blob.type || "image/jpeg" });
  } catch {
    return null;
  }
};

// Items already created are removed from the form so a retry after a failure does not duplicate them.
const crearUno = async (items, key, set, crear) => {
  for (let i = 0; i < items.length; i += 1) {
    try {
      await crear(items[i]);
    } catch (e) {
      set({ [key]: items.slice(i) });
      throw e;
    }
  }
  set({ [key]: [] });
};

// Saves one optional step through the same endpoints the full screens use.
export const guardarOpcional = async (paso, d, ctx, set) => {
  const { id } = ctx;
  switch (paso.id) {
    case "imagenes":
      if (hayImagenes(d)) await organizerUpdateEventApi(formDataImagenes(id, d));
      return;
    case "compra": {
      const remotos =
        d.tipo === "pagas" ? lista(await organizerTicketTypesByEventApi({ eventid: id })) : [];
      await organizerUpdateEventApi(formDataCompra(id, d, remotos));
      return;
    }
    case "cupones":
      await crearUno(d.cupones, "cupones", set, (c) => organizerCreateCouponApi(payloadCupon(id, c)));
      return;
    case "difusion":
      await crearUno(d.sponsors, "sponsors", set, (s) => organizerAddSponsorApi(formDataSponsor(id, s)));
      if (d.pixel.trim()) await organizerUpdateEventApi(formDataPixel(id, d));
      return;
    case "certificados":
      await organizerUpdateEventApi(formDataCertificados(id, d, d.cert ? await plantillaPorDefecto() : null));
      return;
    default:
  }
};
